import React, { useState, useEffect } from "react";
import DropDownInput from "../../../../Universal/DropDownInput.component";
import { ReactComponent as CrossIcon } from "../../../../../assets/Icons/Universal/CloseBtnIcon.svg";
const AddProgramSubject = ({
  index,
  program,
  addNewProgram,
  removeProgram,
}) => {
  const [inputsVal, setInputsVal] = useState(program);
  useEffect(() => {
    addNewProgram(inputsVal);
    // eslint-disable-next-line
  }, [inputsVal]);

  return (
    <div className="flex-row align-center justify-between g-1">
      <div className="flex-1 flex-row align-center justify-start g-05">
        <div className="flex-col align-start justify-start g-05">
          <label htmlFor={`subjectName-${index}`} className="t-12 poppins">
            Subject Name
          </label>
          <input
            type={"text"}
            placeholder={"Enter Subject Name"}
            name={"subjectName"}
            value={inputsVal.subjectName}
            onChange={(e) =>
              setInputsVal({ ...inputsVal, subjectName: e.target.value })
            }
            className={`programSubjectAddInput`}
          />
        </div>

        {/* <div className="flex-col align-start justify-start g-05">
        <label htmlFor={`subjectType-${index}`} className="t-12 poppins">
          Subject Type
        </label>
        <input
          type={"text"}
          placeholder={"Enter Subject Type"}
          name={"subjectType"}
          value={inputsVal.subjectType}
          onChange={(e) =>
            setInputsVal({ ...inputsVal, subjectType: e.target.value })
          }
          className={`programSubjectAddInput`}
        />
      </div> */}
        <div className="flex">
          <DropDownInput
            label={"Subject Type"}
            type="select"
            name={"subjectType"}
            value={inputsVal.subjectType}
            placeholder={"Choose subject type"}
            setFieldValue={(val) =>
              setInputsVal({ ...inputsVal, subjectType: val })
            }
            suggestionList={["list 1", "list 2"]}
          />
        </div>
        <div className="flex-col align-start justify-start g-05">
          <label htmlFor={`subjectCode-${index}`} className="t-12 poppins">
            Subject Code
          </label>
          <input
            type={"text"}
            placeholder={"Enter Subject Code"}
            name={"subjectCode"}
            value={inputsVal.subjectCode}
            onChange={(e) =>
              setInputsVal({ ...inputsVal, subjectCode: e.target.value })
            }
            className={`programSubjectAddInput`}
          />
        </div>
      </div>
      <button
        type="button"
        className="transparentBtn flex align-center justify-center mt-1"
        style={{
          width: "1.5rem",
          height: "1.5rem",
          borderRadius: "50%",
          background: "var(--redColor)",
          padding: "5px",
        }}
        onClick={() => removeProgram(inputsVal)}
      >
        {/* <img src={CrossIcon} alt="" /> */}
        <CrossIcon className="w-full h-full" style={{ objectFit: "cover" }} />
      </button>
    </div>
  );
};

export default AddProgramSubject;
